import React from 'react'

import ItemCard from '../itemCard'

const ListDefault = ({
  items,
  viewType,
  currentSite,
  itemDecorator,
  videoMuted,
  muteVideo
}) => {
  return (
    <ul data-test-selector="list-layout" className="product-list">
      {items.map((item, index) => {
        return (
          <li key={item.id}>
            <ItemCard
              currentSite={currentSite}
              viewType={viewType}
              itemProps={itemDecorator(item, index)}
              videoMuted={videoMuted}
              muteVideo={muteVideo}
            />
          </li>
        )
      })}
    </ul>
  )
}

export default ListDefault



// WEBPACK FOOTER //
// ./client/components/productList/listDefault.js